import { T } from '@territory/tokens';
import { REDUCED_MOTION } from './useStyleOnce.js';
import { shopLookRole } from './shopRoles.js';

/*
 * The storefront floating round button (apps/shop legacy .to-top), for IconButton variant="shop-float". Verbatim from
 * the shipped styles.css so the port is a visual no-op. The sheet paints the circle only: the fixed position, z-index and
 * the show or hide (opacity, translate, pointer-events) stay in the shop. The transition list carries opacity and
 * transform so the shop's show or hide still eases. The glyph (an img or svg child) turns 90deg on hover.
 */

/* verbatim .to-top, off-scale */
const SIZE = 46;
const BLUR = 8;
const MS = 0.3;
const GLYPH_MS = 0.5;

const SEL = ':where([data-rv-icon-button])[data-rv-variant="shop-float"]';
const GLYPH = `${SEL} > :is(img, svg)`;
const ms = (props: string[], s: number): string => props.map((p) => `${p} ${s}s ${T.ease}`).join(', ');

export const SHOP_FLOAT_CSS = `${SEL} { box-sizing: border-box; display: grid; place-items: center; width: ${SIZE}px; height: ${SIZE}px; padding: 0; border-radius: 50%; border: 1px solid ${T.separatorBold}; background: ${shopLookRole('float-fill', T.bgElev)}; -webkit-backdrop-filter: blur(${BLUR}px); backdrop-filter: blur(${BLUR}px); color: ${T.label}; cursor: pointer; transition: ${ms(['opacity', 'transform', 'border-color'], MS)}; }
${GLYPH} { transition: transform ${GLYPH_MS}s ${T.ease}; }
${SEL}:hover { border-color: ${T.accent}; }
${SEL}:hover > :is(img, svg) { transform: rotate(90deg); }
${REDUCED_MOTION} { ${SEL}:hover > :is(img, svg) { transform: none; } }`;
